// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1ZOgB{display:-ms-flexbox!important;display:flex!important;-ms-flex-align:center!important;align-items:center!important;-ms-flex-pack:center!important;height:100%!important;justify-content:center!important;width:100%!important}", ""]);
// Exports
exports.locals = {
	"avatar__initials_container": "_1ZOgB"
};
module.exports = exports;
